import { UserProfile, WalletItem } from '@/types/user';
import { apiSlice } from './apiSlice';

export const userApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // users/me
    getUserProfile: builder.query<UserProfile, void>({
      query: () => ({
        url: '/users/me',
        method: 'GET',
        params: { t: Date.now() },
      }),
      providesTags: ['UserDetails'],
    }),

    // Get current user's wallets
    getUserWallets: builder.query<WalletItem[], void>({
      query: () => ({
        url: `/users/me/wallets`,
        method: 'GET',
        params: { t: Date.now() },
      }),
    }),
  }),
});

export const { useGetUserProfileQuery, useGetUserWalletsQuery } = userApi;
